import $ from 'jquery'

$('[data-toggle=chooser]').on('change', function (event) {
  $(this).find('.chooser-item').removeClass('active')
  $(event.target).closest('.chooser-item').addClass('active')
})
